module.exports = __webpack_public_path__ + "static/media/cpx.eb64b89d.jpg";